import { CommonModule } from '@angular/common';
import { PaginationControlsModule } from 'Angular/features/components/pagination/pagination-controls/pagination-controls.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class ListPagePaginationModule {
}
ListPagePaginationModule.ɵfac = function ListPagePaginationModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ListPagePaginationModule)(); };
ListPagePaginationModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ListPagePaginationModule });
ListPagePaginationModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, PaginationControlsModule] });
